import { Base, createApp, importWhenVisible } from '@studiometa/js-toolkit';
import { Action, Panel } from '@studiometa/ui';
import Cart from './molecules/Cart/index.js';
import Toast from './atoms/Toast/index.js';
import 'liquid-ajax-cart';
import ProductInfo from './organisms/ProductInfo.js';
import SearchForm from './molecules/SearchForm.js';
import PanelDescriptionButton from './molecules/PanelDescriptionButton.js';
import Slider from './molecules/Slider/index.js';
import ScrollToTop from './atoms/ScrollToTop.js';
import SliderReassurance from './molecules/SliderReassurance.js';
import SliderFit from './molecules/SliderFit.js';
import Header from './organisms/Header.js';
import PopinNewsletter from './molecules/PopinNewsletter.js';

/**
 * App
 */
class App extends Base {
  /**
   * App Configuration
   */
  static config = {
    name: 'App',
    components: {
      Header,
      Action,
      Toast,
      Cart,
      ProductInfo,
      SearchForm,
      ScrollToTop,
      Slider,
      Video: (app) => importWhenVisible(() => import('./atoms/Video.js'), 'Video', app),
      Accordion: (app) =>
        importWhenVisible(() => import('./molecules/Accordion/index.js'), 'Accordion', app),
      PanelDescription: Panel,
      PanelDescriptionButton,
      Panel,
      SliderReassurance,
      SliderFit,
      PopinNewsletter,
    },
  };

  /**
   * Toaster
   * @returns {Toast}
   */
  get Toaster() {
    if (this.$children.Toast.length <= 0) {
      throw new Error('No Toast component found');
    }

    return this.$children.Toast[0];
  }

  /**
   * PanelDescription
   * @returns {PanelDescription}
   */
  get PanelDescription() {
    return this.$children.PanelDescription[0];
  }
}

export default createApp(App, document.body);
